// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__171jy","resendInfoText":"OnGoingPaymentBox_resendInfoText__RcdLT"};